import { Box, Button, Text } from "@mantine/core";
import { WarningIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import classes from "./load-error.module.css";

type Props = {
  onRetry: () => void;
  /** Shown as a second, quiet button when the screen has filters to reset. */
  onClear?: () => void;
};

/** Shared «could not load» state of the settlement list and detail. */
export function SettlementLoadError({ onRetry, onClear }: Props) {
  const { t } = useTranslation("settlement");
  return (
    <Box className={classes.state} role="alert">
      <WarningIcon size={36} color="var(--mantine-color-gray-6)" />
      <Text className={classes.title}>{t("error.loadTitle")}</Text>
      <Text className={classes.text}>{t("error.loadText")}</Text>
      <Box className={classes.actions}>
        <Button variant="default" onClick={onRetry}>
          {t("error.retry")}
        </Button>
        {onClear && (
          <Button variant="subtle" color="gray" onClick={onClear}>
            {t("clearFilters")}
          </Button>
        )}
      </Box>
    </Box>
  );
}
